import {Component, Input} from '@angular/core';

import {ZoneDescriptor} from './form-generator.interfaces';

@Component({
  selector: 'gp-form-field-mapping-indicators',
  template: `
    <ng-container *ngIf="descriptor?.metadatas?.mappingTypes as mappingTypes">
      <em *ngFor="let mappingType of mappingTypes"
          [ngClass]="['MAPPING.icon.' + mappingType | translate, 'MAPPING.color.' + mappingType | translate]"
          [tooltip]="'MAPPING.type.' + mappingType | translate"
          [placement]="'right'"
          class="fa-light m-r-xs"
          [attr.test-id]="'mapping-indicator-' + mappingType"></em>
    </ng-container>
  `,
  styleUrls: ['./form-field-mapping-indicators.component.scss']
})
export class FormFieldMappingIndicatorsComponent {

  @Input()
  public descriptor: ZoneDescriptor;

}
